import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import { Link, useLocation, useParams } from "react-router-dom";
import "../../../assets/css/cms/Products.css";
import loadable from "@loadable/component";
import Loading from "../../utils/loader";
import { useSelector } from "react-redux";
import { CHECK_PERMISSION } from "../../../constants/cms"
import PermissionDenied from "../common/permissionDenied";
import { connect } from "react-redux";
import { PollsListing } from "./polls/listing";
import { ManagePolls } from "./polls/managePolls";
import CommentModeration from "./commentModeration";
import { ManageComments } from "./commentModeration/editComments";


export const PollsHome = (props) => {
    const router = useLocation();
    const { params } = useParams();
    let relatedPath = router.pathname.split("/add-edit")[0];
    const [activeComponent, setActiveComponent] = useState();
    const { userPermission } = useSelector((state) => {
        return state.userData;
    });

    // checking permission to show tabs
    const findPermission = (application, action) => {
        let authorized = false;
        const userPermissions = userPermission?.data;
        if (userPermissions) {
            authorized = userPermissions.some(permission => {
                return permission.content_type === application && permission.name === action
            });
        }
        return authorized;
    }

    let POLLS_ROUTES = [
        { path: "/cms/polls", exact: true, value: "Poll Management", element: <PollsListing /> },
        { path: "manage-polls", exact: true, element: <ManagePolls /> },
        { path: "/cms/polls/comment-moderation", exact: true, value: "Comment Moderation", element: <CommentModeration /> },
        { path: "manage-comment-moderation", exact: true, element: <ManageComments /> },
    ];

    useEffect(() => {
        if (params) {
            let activeComponent = POLLS_ROUTES.find((obj) => {
                if (obj.path?.includes(params)) {
                    return obj;
                }
            });
            if (activeComponent && activeComponent?.application && activeComponent?.action && !findPermission(activeComponent?.application, activeComponent?.action)) {
                setActiveComponent(<PermissionDenied />)
            }
            else {
                setActiveComponent(activeComponent?.element);
            }
        } else {
            setActiveComponent(POLLS_ROUTES[0].element);
        }
    }, [params]);

    return (
        <div>
            <div className={"nav_container"}>
                <Nav className={"sub_nav"}>
                    {POLLS_ROUTES.map((route, index) => {
                        const isActive = relatedPath === route.path || router.pathname === route.path;
                        return (
                            <Nav.Item key={index} className={isActive ? "nav_links_active" : ""}>
                                <Nav.Link>
                                    <Link to={route.path}>{route.value}</Link>
                                </Nav.Link>
                            </Nav.Item>
                        );
                    })}
                </Nav>
            </div>
            {/* <DyanamicRoutes {...props} /> */}
            {activeComponent}
        </div>
    );
}